import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import TalentsPage from "./pages/Talents";
import TantactPage from "./pages/Tantact";
import CasePage from "./pages/Case";
import LeaveWordPage from "./pages/LeaveWord";
import NewsPage from "./pages/News";
import DetailPage from "./pages/Detail";
import ProductPage from "./pages/Product";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/case" element={<CasePage />} />
            <Route path="/talents" element={<TalentsPage />} />
            <Route path="/leaveWord" element={<LeaveWordPage />} />
            <Route path="/tantact" element={<TantactPage />} />
            <Route path="/detail" element={<DetailPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
